import { render } from "./categoryEvents.vue?vue&type=template&id=1d376628"
import script from "./categoryEvents.vue?vue&type=script&lang=js"
export * from "./categoryEvents.vue?vue&type=script&lang=js"

import "./categoryEvents.vue?vue&type=style&index=0&id=1d376628&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__